<template>
    <div class="container">
        <div class="common-header-wrap">
            <div>
                <div class="ui-detail-header">
                    <span class="iconfont" @click="goBack">&#xe6ee;</span>
                    <div class="navbar-wrapper">
                         {{titleName}}
                    </div>
                    <span class="iconfont right" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div></span>
                </div>
                <header-more  v-show="popupVisible" ></header-more>
            </div>
        </div>
        <Empty description="暂无数据" v-if="!activity_isuse"  />
        <template v-else>
            <div v-if="activeIndex === 0" style="height:calc(100vh - 93px);overflow:auto">
                <div class="banner-top">
                    <img class="bg-img" :src="banner" alt="">
                    <!-- <div class="info-img-div" src="../../assets/image/explain-img.jpg" alt=""> -->
                    <!-- <div class="info-img-div">
                        <img :src="banner" alt="">
                    </div> -->
                </div>
                <div class="warp">
                    <Tabs v-model="active" animated sticky @change="handleChange">
                        <Tab v-for="(items,index) in activity_fen" :title="items.class_name" :key="index">
                            <div >
                                <List
                                    v-model="loading"
                                    :finished="finished"
                                    finished-text="没有更多了"
                                    @load="onLoad"
                                    :offset="100"
                                    v-if="dataList.length"
                                > 
                                <template v-for="(item,idss) in dataList" >
                                    <div class="list-item" v-if="item.vouchertemplate_gettype != '2'" :key="idss" > 
                                        <img class="bg-list-img" v-if="item.isLq" src="../../assets/image/list-zd.png" alt="">
                                        <img class="bg-list-img" v-else src="../../assets/image/list.png" alt="">
                                        <div class="list-content">
                                            <div class="list-left">
                                                <p class="title">{{item.vouchertemplate_title}}</p>
                                                <ul>
                                                    <li v-for="(its,idx) in item.good_commend" @click="handleGoGoods(its)" :key="index+idx">
                                                        <img :src="its.goods_image" alt="">
                                                        <p class="red">¥{{its.goods_price}}</p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="list-right">
                                                <img src="../../assets/image/ylq.png" v-if="item.isLq" alt="">
                                                <p class="money"><span>¥</span>{{item.vouchertemplate_price}}</p>
                                                <p class="money-sub">满{{item.vouchertemplate_limit}}可用</p>
                                                <div class="btn btn-diss" v-if="!item.iscan_receive">已领取</div>
                                                <template v-else>
                                                    <div class="btn btn-dis" @click="handleQwsy(item)" v-if="item.isLq">去使用</div> 
                                                    <div class="btn" @click="handleGetJuan(idss)" v-else>立即领取</div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="list-item-zd" v-else  :key="idss">
                                        <img class="bg-list-img" src="../../assets/image/list-zd.png" alt="">
                                        <div class="list-content">
                                            <div class="list-left" @click="handleGoGoods(item.good_commend[0])">
                                                <img :src="item.good_commend[0].goods_image"  alt="">
                                            </div>
                                            <div class="list-right">
                                                <img src="../../assets/image/ylq.png" v-if="item.isLq" alt="">
                                                <p class="title">{{item.vouchertemplate_title}}</p>
                                                <p style="font-size:12px;color:#999;line-height:12px;margin-top:5px;">商城价：<span style="text-decoration: line-through;">{{item.vouchertemplate_limit}}</span></p>
                                                <div>
                                                    <p class="money"><span style="color:#666;font-size:14px;">用券后</span>&nbsp;¥<span>{{item.vouchertemplate_price}}</span></p>
                                                     <div  class="btn btn-diss" v-if="!item.iscan_receive">已领取</div>
                                                     <template v-else>
                                                        <div class="btn btn-dis"  @click="handleQwsy(item)" v-if="item.isLq">去使用</div>
                                                        <div class="btn" @click="handleGetJuan(idss)" v-else>领券</div> 
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </template>
                                
                                <!-- <div v-for="item in list" :key="item"> {{item}}</div> -->
                                </List>
                            
                            </div>
                            <Empty description="暂无数据" v-if="!dataList.length"  />
            
                        </Tab>
                    </Tabs>
                </div>
            
            </div>
        </template>
       <mt-popup v-model="showDialog" popup-transition="popup-fade" class="popup" >
            <div class="pop-content">
                <div class="pop-img">
                    <img src="../../assets/image/tick.png" />
                    <p>领券成功！感谢您的参与，祝您购物愉快~</p>
                </div>
                
                <div class="pop-btn" @click="showDialog=false">确定</div>
            </div>
        </mt-popup>
        <div class="discount-footer">
           <div :class="activeIndex === 0 ?'active':''" @click="handleClickFooter(0)">
               <img v-if="activeIndex === 0" src="../../assets/image/youhuiquan1.png" alt="">
               <img v-else src="../../assets/image/youhuiquan.png" alt="">
                <p>领代金券</p>
           </div>
            <div  :class="activeIndex === 1 ?'active':''" @click="handleClickFooter(1)">
               <img v-if="activeIndex === 1" src="../../assets/image/wode1.png" alt="">
               <img v-else src="../../assets/image/wode.png" alt="">
                <p>我的代金券</p>
           </div>
        </div>
        <div class="loading-warp" v-if="isloading">
           <img src="../../assets/image/new_mp_loade.gif" alt="">
            <p>加载中...</p>
        </div>
    </div>
</template>
<script>
import { getPointbycode, getVoucherCount,getVoucherList} from '../../api/discountCoupon'
import { Toast ,Indicator} from 'mint-ui'
import EmptyRecord from '../../components/EmptyRecord'
import HeaderMore from '../HeaderMore'
import { vactInfo ,vact_fdetail,vact_receive} from '../../api/reelCenter'
import Tab from 'vant/lib/tab';
import 'vant/lib/tab/style';
import Tabs from 'vant/lib/tabs';
import 'vant/lib/tabs/style';
import List from 'vant/lib/list';
import 'vant/lib/list/style';
import Empty from 'vant/lib/empty';
import 'vant/lib/empty/style';

import { mapState } from 'vuex'
export default {
  name: 'reelCenter',
  components: {
    EmptyRecord,
    HeaderMore,
    Tab,
    Tabs,
    List,
    Empty
  },
  data () {
    return {
      banner:'',
      activity_fen:[],
    active:0,
    ac_id:'',
    dataList:[],
          page:1,
      selected: 1,
      activeIndex: 0,
      isDx:false, // 点了兑换
      code:'',
      yhjInfo:{},
      num1:0,
      num2:0,
      num3:0,
      isMore: true, // 是否有更多
      popupVisible: false,
      showDot:false,
      tjData:[],
      list: [],
      loading: false,
      finished: false,
      isFirst:true,
      hasmore:false,
      showDialog:false,
      activity_isuse: 0 ,// 关闭 1 开启
      titleName: '领卷中心',
      isloading:false
    }
  },
  computed: mapState({
    token: state => state.member.token
  }),
  created() {
    this.initPage()
  },
  methods: {
    handleGetJuan(index) {
        vact_receive({id:this.dataList[index].id,key:this.token}).then(res => {
            if (res.code === 10000) {
                this.showDialog = true
                setTimeout(() => {
                    this.$set(this.dataList[index],'isLq',true)  
                },100)
            }   
        }).catch(function (error) {
            Toast(error.message)
        })
    },
    onLoad() {
        if (this.isFirst) return
        if (!this.hasmore) return
        this.page = this.page + 1
        vact_fdetail({
           activity_id: this.$route.query.activity_id || '14',
           ac_id: this.ac_id,
           page: this.page,
           per_page: 5
        }).then(res => {
            if(res.code === 10000) {
                if (this.page === 1) {
                  this.dataList = res.result.adv_list || []  
                } else {
                  res.result.adv_list = res.result.adv_list || []
                  this.dataList = this.dataList.concat(res.result.adv_list)
                }
                this.loading = false
                this.hasmore = res.result.hasmore
                if(!this.hasmore) {
                    this.finished = true
                }

            }
        }).catch(function (error) {
            Toast(error.message)
        })
    },
    initPage() {
        let id = this.$route.query.activity_id || '14'
        this.isloading = true
       vactInfo(id,this.token||'').then(res => {
           this.isloading = false
           if(res.code === 10000) {
               this.banner = res.result.activity.banner
               this.activity_isuse = res.result.activity.activity_isuse
               this.titleName = res.result.activity.title
               this.activity_fen = res.result.activity_fen || []
               this.ac_id = this.activity_fen.length ? this.activity_fen[this.active].id : ''
               this.dataList = res.result.adv_list || []
               this.tjData = JSON.parse(JSON.stringify(this.dataList))
               this.activity_fen.unshift({class_name:'推荐'})
               this.isFirst = false
               this.finished = true
           }
       }).catch(function (error) {
           this.isloading = false
            Toast(error.message)
        })
    },
    
    handleChange() {
       this.page = 1
       this.hasmore = false
       this.ac_id =  this.activity_fen[this.active].id
        if (!this.ac_id) {
            this.dataList = JSON.parse(JSON.stringify(this.tjData))
            return
        }
        Indicator.open()
       vact_fdetail({
           activity_id: this.$route.query.activity_id || '14',
           key: this.token || '',
           ac_id: this.ac_id,
           page: this.page,
           per_page: 5
       }).then(res => {
           Indicator.close()
            if(res.code === 10000) {
                this.dataList = res.result.adv_list || []
                this.hasmore = res.result.hasmore
                if(!this.hasmore) {
                    this.finished = true
                } else {
                    this.finished = false
                }
            }
       }).catch(function (error) {
           Indicator.close()

            Toast(error.message)
        })

    },
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    },
    goBack () {
      this.$router.go(-1)
    },
     dateToStr(times){ 
        let datetime = new Date(times)
        var year = datetime.getFullYear();
        var month = datetime.getMonth()+1;//js从0开始取 
        var date = datetime.getDate(); 
        return year + "." + month + "." + date;
    },
    handleClickDx() {
       
      let params = { 'page': 0, 'per_page': 1 }
      getPointbycode(this.code).then(res => {
         this.isDx = true
        //  getVoucherList({...params}).then(ress => {
        //     console.log(this.yhjInfo,'this.yhjInfo')
            this.yhjInfo = res.result || {}
            this.yhjInfo.startdate = this.dateToStr(this.yhjInfo.voucher_startdate*1000)
            this.yhjInfo.enddate = this.dateToStr(this.yhjInfo.voucher_enddate*1000)

        //  })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    alignClick() {
      this.isDx = false
      this.code = ''
    },
    handleClickFooter(index) {
       this.activeIndex = index
       if (index === 1) {
            this.$router.push({
                name:'discountCoupon',
                query:{
                    activeIndex: 1
                }
            })
       }
    },
    handleQwsy(item) {
        if (item.vouchertemplate_gettype == '1') {
           this.$router.push({
                name:'HomeStoredetail',
                query:{
                id: item.vouchertemplate_store_id
                }
            })
        } else if (item.vouchertemplate_gettype == '2') {
            this.$router.push({
                name:'HomeGoodsdetail',
                query:{
                  goods_id: item.vouchertemplate_goods_id
                }
            })
        } else {
            this.$router.push({
                name:'HomeIndex'
            })
        }
        
    },
    handleGoGoods(item) {
         this.$router.push({
            name:'HomeGoodsdetail',
            query:{
                goods_id: item.goods_id
            }
        })
    }
    
  },
}
</script>
<style scoped lang="scss">
    .container .tab-nav{margin-bottom:.5rem}
    .container .tab-containt{height: 0;overflow: hidden}
    .container .tab-containt.active{height: auto}
    .discount-footer {
        position: fixed;
        width:100%;
        left:0;
        bottom:0;
        background: #fff;
        display:flex;
        height: 2.5rem;
        line-height: 2.5rem;
        background: #fff;
        border-top: 1px solid #efefef;
        z-index: 99;
    }
    .discount-footer div {
        display:flex;
        flex-direction:column;
        align-items: center;
        justify-content: center;
        flex:1;
        
    }
    .discount-footer div.active {
        color:#e93b3d;
    }
    .discount-footer div p{
       font-size:0.6rem;
       line-height: 1.2;
    }
    .discount-footer div img{
        width: 1.2rem;
       height: 1.2rem;
    }
    .content-warp {
        height: calc(100vh - 4.5rem);
        background: #fff;
        padding:.7rem;
        font-size:.7rem;
        line-height: 1.5;
    }
    .content-warp input {
        width: calc(100% - 0.5rem);
        margin:0.25rem;
        height:2rem;
        margin-top:2rem;
        padding:0 .7rem;
        box-sizing: border-box;
    }
    .content-warp1 {
        background: #f5f5f5;
    }
    .content-warp1 p {
        text-align: center;
    }
    .content-warp1 > div {
                padding:1rem 0;
    }
    .border-b{
       border-bottom:1px solid #666;
    }
    .content-warp1 .bottom {
        padding-left:30px;
        padding-right: 30px;
    }
    .content-warp1 .bottom p {
        text-align: left;

    }
     .content-warp1 .mint-button--normal {
         background: #aaa;
    }
     .ui-detail-header {
	padding: 0 0.45rem;
	// height:3.2rem;
	background: rgba(255, 255, 255, 1);
	border-bottom: 1px solid rgba(232, 234, 237, 1);
	color: #55595f;
	font-size: 0.8rem;
	width: auto;
	display: flex;
	justify-content: center;
	align-content: center;
	align-items: center;
	flex-basis: auto;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	.iconfont {
		width: 1.2rem;
		font-size:0.8rem;
		height: 1.2rem;
		line-height:1.2rem;
		cursor: pointer;
		position: absolute;
		left: 0.45rem;
		top: 0.5rem;
	}
	.iconfont.right{left:auto;right:0.45rem;-webkit-tap-highlight-color: transparent;}
	div.navbar-wrapper {
		line-height: 2.1rem;
		div {
			// line-height: 2.1rem;
			border-bottom: 0;
			display: inline-block;
			margin-right:2.4rem;
			color: #55595f;
			background-color: #fff;
			&.navbar_active {
				color: $primaryColor;
				border-bottom: 0.1rem solid $primaryColor;
			}
			&:last-child {
				margin-right: 0;
			}
			&:focus {
				outline: none;
			}
		}
	}
}
    .banner-top {
        .bg-img {
            width: 100vw;
        }
        .info-img-div {
           position: relative;
            width: calc(100vw - 30px);
            padding-top: 45%;
            height:0;
            margin-top:-120px;
            margin-left: 15px;
            img {
                width:100%;
                height:100%;
                object-fit: cover;
                position: absolute;
                top:0;
                left:0;
            }
        }
    }
    .list-item {
        position: relative;
        margin: 0 auto;
        width: calc(100vw - 20px);
        .bg-list-img {
            width:100%;
        }
        .list-content {
            position: absolute;
            left:5px;
            top:0;
            width: calc(100vw  - 30px);
            height:100%;
            display: flex;
            >div {
                height:100%;
                display: flex;
                align-content:center;
                justify-content: center;
                flex-direction:column;
                   box-sizing: border-box;

            }
            .list-left {
               width:71.5%;
               padding:0 20px;
                box-sizing: border-box;

               .title {
                    font-size: 14px;
                    color: #252525;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-weight: 600;
               }
               ul {
                   width: 100%;
                   box-sizing: border-box;
                   display:flex;
                   justify-content: space-between;
                   margin-top:5px;
                   li {
                       img {
                           width:60px;
                           height:60px;
                           object-fit: cover;
                       }
                       p {
                           font-size:12px;
                           line-height: 1.5;
                           text-align: center;
                           transform: scale(0.9);
                       }
                   }
               }
            }
             .list-right {
               width:28.5%;
                 display: flex;
                align-content:center;
                justify-content: center;
                flex-direction:column;
                   box-sizing: border-box;
                   align-items: center;
               color:#f2270c;
               .money {
                   font-size: 24px;
                   font-weight: 600;
                   line-height: 1;
                   
                   span {
                       font-size: 16px;
                   }
               }
               .money-sub {
                    font-size: 12px;
                   line-height: 1;

               }
               img {
                   width:50px;
                   position: absolute;
                   top:5px;
                   right:0;
               }
            }
        }
    }
      .btn {
                    height:24px;
                    line-height: 24px;
                    border-radius: 15px;
                    background: #e93b3d;
                    color:#fff;
                    font-size:12px;
                    width:70px;
                    text-align: center;
                    margin-top:15px;
                }
                .btn-dis {
                    background: #fff;
                    color:#e93b3d;
                    border:1px solid #e93b3d;
                }
                .btn-diss {
                    background: #999;
                    color:#999;
                    border:1px solid #999;
                    color:#fff;
                }
    .list-item-zd {
        position: relative;
        margin: 0 auto;
        width: calc(100vw - 20px);
        .bg-list-img {
            width:100%;
        }
        .list-content {
            position: absolute;
            left:5px;
            top:0;
            width: calc(100vw  - 30px);
            height:100%;
            display: flex;
            >div {
                height:100%;
            }
            .list-left {
                width:35%;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width:100px;
                    height:100px;
                }
            }
            .list-right {
                display: flex;
                align-content:center;
                justify-content:space-between;
                flex-direction:column;
                box-sizing: border-box;
    
                padding:25px 12px;
                      flex:1;
                .title {
                    font-size: 14px;
                    color: #252525;
                    overflow:hidden; 
                    text-overflow:ellipsis;
                    display:-webkit-box; 
                    -webkit-box-orient:vertical;
                    -webkit-line-clamp:2; 
                    font-weight: 600;
                }
                >div{
                  display: flex;
                  font-size: 14px;
                  align-items: center;
                  color:#f5686d;
                              justify-content: space-between;
                  span {
                      font-size: 20px;
                      font-weight: 600;
                  }
                }
                .btn {
                    margin-top:0;
                }
                 img {
                   width:50px;
                   position: absolute;
                   top:5px;
                   right:0;
               }
                
            }
        }
        
    }
    .mint-popup {
      border-radius: 10px;
      overflow: hidden;
    }
        .pop-content {
            width:80vw;
            background: #fff;
            .pop-img {
                padding:25px 25px 5px;
                text-align: center;
                font-size: 16px;
                img {
                    width:60px;
                }
            }
            .pop-btn {
                margin-top:20px;
                line-height: 50px;
                text-align: center;
                font-size: 16px;
                border-top:1px solid #f3f3f3;
                color:#e93b3d;
                cursor: pointer;
                &:active {
                    background: #f2f2f2;
                }
            }
        }
        .red {
            color:#e93b3d;
        }
       /deep/ .van-tab {
            color:#999;
        }
        /deep/ .van-tab--active {
            color:#323233;
        }
        .loading-warp {
            width:100vw;
            height:100vh;
            position: fixed;
            top:0;
            left:0;
            background: rgba(0,0,0,0.5);
            z-index:10000;
            text-align: center;
            img {
                width:100px;
                margin-top:50%;
            }
            p {
                font-size:14px;
                color:#fff;
                margin-top:10px;
            }
        }
</style>
